export default __webpack_public_path__ + "static/media/0xe52509181feb30eb4979e29ec70d50fd5c44d590.92bb663d.webp";